(function () {
  'use strict';

  let isInitialized = false;
  let isProcessingRequest = false;
  let processedRequests = new Set();
  let allSizeVariants = [];
  let sizeVariantStocks = {};
  let sizeDistribution = {};
  let variantDistributions = {};
  let isBedenSetiFormat = false;
  let minStockQuantity = 0;
  let availableSizes = [];
  let internalRequestFlag = 'SET_MULTIPLIER_INTERNAL_REQUEST';
  let isPaketYapisiFormat = false;
  let paketMultiplier = 1;
  const PRODUCTION_MODE = false; // debug konsol logları AÇIK ([Set Multiplier] ...); kullanıcı isteğiyle geri açıldı

  // ===== i18n / Çoklu dil desteği =====
  const I18N_STRINGS = {
    tr: {
      bedenSetiTitle: 'Beden Seti:',
      bedenSetiAutoDesc: 'Ürünler, seçtiğiniz bedene göre farklı miktarlarda otomatik olarak sepetinize eklenecektir.',
      rangeNotice: '<span style="color: #007cba; font-weight: 500;">{range}</span> seçerseniz → <strong>{qty} adet</strong> ürün eklenecektir',
      paketTitle: 'Paket Ürün:',
      paketDescription: 'Sipariş ettiğiniz her 1 adet için {qty} adet ürün sepetinize eklenecektir.',
      paketSubtitle: 'Bu ürün paket olarak satılmaktadır.',
      setTitle: 'Set Ürün:',
      setStdDescription: 'Sipariş ettiğiniz her 1 adet için {qty} adet ürün sepetinize eklenecektir.',
      setSubtitle: 'Bu ürün set olarak satılmaktadır.',
      setMultiDescription: 'Her birim için, farklı bedenlerde {qty} ürün sepetinize eklenecektir.',
      distributionLabel: 'Dağılım:',
      pcsUnit: 'adet',
      pkgUnit: 'paket',
      pkgUnitPlural: 'paket',
      setUnit: 'set',
      maxAddableLabel: 'Maksimum eklenebilir:',
      limitingFactorLabel: 'Sınırlayıcı faktör:',
      yourSelectionLabel: 'Seçiminiz:',
      addingToCartLabel: 'Sepete ekleniyor:',
      detailsLabel: 'Detaylar:',
      cantAddTitle: '⚠ Eklenemez',
      setProcessingMsg: 'Set işleniyor...',
      productsAddedMsg: '{qty}{formatInfo} ({total} adet) ürün eklendi',
      formatSetSize: ' (Beden Seti)',
      formatPackage: ' (Paket)',
      formatSet: ' (Set)',
      cantAddIntegrityMsg: 'Ürün sepete eklenemedi çünkü set bütünlüğü sağlanamıyor.',
      missingSizesErr: 'Eksik bedenler: {sizes}',
      insufficientStockMaxSetsErr: 'Stok yetersiz. Maksimum {max} set eklenebilir. Sınırlayıcı faktör: {factor}',
      insufficientStockSimpleErr: 'Stok yetersiz: {available} < {needed}',
      sizeNotFoundErr: '{size} bedeni bulunamadı',
      pkgInsufficientWarn: 'Stok yetersiz! Bu paket ürün sepete eklenemez.',
      stdInsufficientWarn: 'Stok yetersiz! Bu ürün sepete eklenemez.',
      setIntegrityWarn: 'Set bütünlüğü sağlanamıyor! Eksik bedenler var.',
      maxAddableWarn: 'Maksimum {max} {format} ({total} adet) eklenebilir!',
      maxSetsOnlyWarn: 'Maksimum {max} set eklenebilir',
      setTotalLabel: 'Set toplamı:',
      unitPriceNote: 'birim',
      addingToCartOverlay: 'Ürünler sepete ekleniyor…'
    },
    ro: {
      bedenSetiTitle: 'Set de mărimi:',
      bedenSetiAutoDesc: 'Produsele vor fi adăugate automat în coșul dumneavoastră în cantități diferite, în funcție de mărimea selectată.',
      rangeNotice: '<span style="color: #007cba; font-weight: 500;">{range}</span> dacă selectați → <strong>{qty} buc.</strong> produse vor fi adăugate',
      paketTitle: 'Produs pachet:',
      paketDescription: 'Pentru fiecare 1 bucată comandată, {qty} bucăți vor fi adăugate în coșul dumneavoastră.',
      paketSubtitle: 'Acest produs se vinde ca pachet.',
      setTitle: 'Produs set:',
      setStdDescription: 'Pentru fiecare 1 bucată comandată, {qty} bucăți vor fi adăugate în coșul dumneavoastră.',
      setSubtitle: 'Acest produs se vinde ca set.',
      setMultiDescription: 'Pentru fiecare bucată, {qty} produse de mărimi diferite vor fi adăugate în coșul dumneavoastră.',
      distributionLabel: 'Distribuție:',
      pcsUnit: 'buc.',
      pkgUnit: 'pachet',
      pkgUnitPlural: 'pachete',
      setUnit: 'set',
      maxAddableLabel: 'Maximum adăugabil:',
      limitingFactorLabel: 'Factor limitativ:',
      yourSelectionLabel: 'Selecția dvs.:',
      addingToCartLabel: 'Se adaugă în coș:',
      detailsLabel: 'Detalii:',
      cantAddTitle: '⚠ Nu se poate adăuga',
      setProcessingMsg: 'Setul se procesează...',
      productsAddedMsg: '{qty}{formatInfo} ({total} buc.) produse adăugate',
      formatSetSize: ' (Set mărimi)',
      formatPackage: ' (Pachet)',
      formatSet: ' (Set)',
      cantAddIntegrityMsg: 'Produsul nu a putut fi adăugat în coș deoarece integritatea setului nu poate fi menținută.',
      missingSizesErr: 'Mărimi lipsă: {sizes}',
      insufficientStockMaxSetsErr: 'Stoc insuficient. Maximum {max} seturi pot fi adăugate. Factor limitativ: {factor}',
      insufficientStockSimpleErr: 'Stoc insuficient: {available} < {needed}',
      sizeNotFoundErr: 'Mărimea {size} nu a fost găsită',
      pkgInsufficientWarn: 'Stoc insuficient! Acest produs pachet nu poate fi adăugat în coș.',
      stdInsufficientWarn: 'Stoc insuficient! Acest produs nu poate fi adăugat în coș.',
      setIntegrityWarn: 'Integritatea setului nu poate fi menținută! Lipsesc mărimi.',
      maxAddableWarn: 'Maximum {max} {format} ({total} buc.) pot fi adăugate!',
      maxSetsOnlyWarn: 'Maximum {max} seturi pot fi adăugate',
      setTotalLabel: 'Total set:',
      unitPriceNote: 'buc.',
      addingToCartOverlay: 'Produsele se adaugă în coș…'
    },
    en: {
      bedenSetiTitle: 'Size Set:',
      bedenSetiAutoDesc: 'Products will be automatically added to your cart in different quantities based on the size you select.',
      rangeNotice: 'If you select <span style="color: #007cba; font-weight: 500;">{range}</span> → <strong>{qty} pcs</strong> will be added',
      paketTitle: 'Package Product:',
      paketDescription: 'For every 1 unit you order, {qty} products will be added to your cart.',
      paketSubtitle: 'This product is sold as a package.',
      setTitle: 'Set Product:',
      setStdDescription: 'For every 1 unit you order, {qty} products will be added to your cart.',
      setSubtitle: 'This product is sold as a set.',
      setMultiDescription: 'For each unit, {qty} products in different sizes will be added to your cart.',
      distributionLabel: 'Distribution:',
      pcsUnit: 'pcs',
      pkgUnit: 'package',
      pkgUnitPlural: 'packages',
      setUnit: 'set',
      maxAddableLabel: 'Maximum addable:',
      limitingFactorLabel: 'Limiting factor:',
      yourSelectionLabel: 'Your selection:',
      addingToCartLabel: 'Adding to cart:',
      detailsLabel: 'Details:',
      cantAddTitle: '⚠ Cannot be added',
      setProcessingMsg: 'Processing set...',
      productsAddedMsg: '{qty}{formatInfo} ({total} pcs) products added',
      formatSetSize: ' (Size Set)',
      formatPackage: ' (Package)',
      formatSet: ' (Set)',
      cantAddIntegrityMsg: 'The product could not be added to the cart because set integrity cannot be maintained.',
      missingSizesErr: 'Missing sizes: {sizes}',
      insufficientStockMaxSetsErr: 'Insufficient stock. A maximum of {max} sets can be added. Limiting factor: {factor}',
      insufficientStockSimpleErr: 'Insufficient stock: {available} < {needed}',
      sizeNotFoundErr: 'Size {size} not found',
      pkgInsufficientWarn: 'Insufficient stock! This package product cannot be added to the cart.',
      stdInsufficientWarn: 'Insufficient stock! This product cannot be added to the cart.',
      setIntegrityWarn: 'Set integrity cannot be maintained! There are missing sizes.',
      maxAddableWarn: 'A maximum of {max} {format} ({total} pcs) can be added!',
      maxSetsOnlyWarn: 'A maximum of {max} sets can be added',
      setTotalLabel: 'Set total:',
      unitPriceNote: 'unit',
      addingToCartOverlay: 'Adding products to cart…'
    }
  };

  function getCurrentLocale() {
    const info = window.productVariantInfo || {};
    const raw = (info.locale || 'tr').toString().toLowerCase();
    const short = raw.slice(0, 2);
    return I18N_STRINGS[short] ? short : 'tr';
  }

  function t(key, vars) {
    const locale = getCurrentLocale();
    const dict = I18N_STRINGS[locale] || I18N_STRINGS.tr;
    let str = dict[key];
    if (str === undefined) str = (I18N_STRINGS.tr[key] !== undefined) ? I18N_STRINGS.tr[key] : key;
    if (vars) {
      for (const k in vars) {
        str = str.split('{' + k + '}').join(vars[k]);
      }
    }
    return str;
  }

  // Debounce helper - tekrarlayan çağrıları engelle
  let debounceTimers = {};
  function debounce(key, callback, delay = 300) {
    clearTimeout(debounceTimers[key]);
    debounceTimers[key] = setTimeout(callback, delay);
  }

  function log(...args) {
    if (!PRODUCTION_MODE) {
      console.log('[Set Multiplier]', ...args);
    }
  }

  function logError(...args) {
    console.error('[Set Multiplier Error]', ...args);
  }

  function initializeMultiplier() {
    if (!window.productVariantInfo) {
      logError('Product variant info not found');
      return false;
    }

    const info = window.productVariantInfo;
    allSizeVariants = info.allSizeVariantIds || [];
    minStockQuantity = info.minStockQuantity || 0;
    availableSizes = (info.allSizes || []).map(s => normalizeSize(s));

    log('Product info loaded:', info.productTitle);

    if (allSizeVariants.length === 0) {
      logError('No size variants found');
      return false;
    }

    parseVariantStocks(info.sizeVariantStocks);

    if (info.isBedenSetiFormat && info.setDistribution &&
      (info.setDistribution.includes('|') || info.setDistribution.includes(','))) {
      isBedenSetiFormat = true;
      variantDistributions = parseVariantDistributions(info.setDistribution);
      log('Beden Seti format detected');
    } else if (info.setDistribution && info.setDistribution.includes('Paket Yapısı:')) {
      isPaketYapisiFormat = true;
      paketMultiplier = parsePaketYapisi(info.setDistribution);
      log('Paket Yapısı format detected, multiplier:', paketMultiplier);
    } else {
      isBedenSetiFormat = false;
      isPaketYapisiFormat = false;
      sizeDistribution = parseSetDistribution(info.setDistribution || 'AUTO');
      log('Traditional format detected');
    }

    if (isBedenSetiFormat) {
      if (Object.keys(variantDistributions).length === 0) {
        logError('Could not parse variant distributions');
        return false;
      }
    } else {
      if (Object.keys(sizeDistribution).length === 0) {
        logError('Could not parse size distribution');
        return false;
      }
    }

    log('Set Multiplier initialized successfully');

    moveSetInfoToCorrectPosition();
    updateSetInfoDisplay();

    return true;
  }

  function parseVariantStocks(stockString) {
    if (!stockString) return;

    const stockPairs = stockString.split(',');
    stockPairs.forEach(pair => {
      const parts = pair.split(':');
      if (parts.length === 2) {
        const variantId = parts[0];
        const stockAndSize = parts[1].split('|');

        if (stockAndSize.length === 2) {
          const stock = parseInt(stockAndSize[0]) || 0;
          const sizeName = stockAndSize[1];
          sizeVariantStocks[variantId] = { stock, sizeName };
        }
      }
    });
  }

  // Optimize edilmiş string temizleme helper fonksiyonu
  function cleanupDistributionText(text) {
    if (!text) return '';
    return text.toString()
      .replace(/<[^>]*>/g, '')
      .replace(/&[a-zA-Z0-9#]+;/g, '')
      .replace(/\*+/g, '')
      .replace(/[\r\n\t\f\v]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function parseSetDistribution(distributionText) {
    if (!distributionText) return {};

    const distribution = {};
    const cleanText = cleanupDistributionText(distributionText);

    log('Parsing distribution text:', cleanText);

    // STD formatını öncelikli olarak kontrol et
    // Pattern 1: "STD-5" formatı
    let stdMatch = cleanText.match(/STD-(\d+)/i) || cleanText.match(/STD\s*[-:]\s*(\d+)/i);
    if (stdMatch) {
      const multiplier = parseInt(stdMatch[1]);
      log(`STD format detected: STD-${multiplier}`);
      distribution['STD'] = multiplier;
      return distribution;
    }

    // Pattern 2: "5xSTANDART" veya "6xSTANDART" formatı
    stdMatch = cleanText.match(/(\d+)\s*x\s*STANDART/i) ||
      cleanText.match(/(\d+)\s*x\s*STD/i) ||
      cleanText.match(/(\d+)xSTANDART/i) ||
      cleanText.match(/(\d+)xSTD/i);

    if (stdMatch) {
      const multiplier = parseInt(stdMatch[1]);
      log(`xSTANDART format detected: ${multiplier}xSTANDART`);
      distribution['STD'] = multiplier;
      return distribution;
    }

    // Pattern 3: Sadece sayı ile STANDART kelimesi
    stdMatch = cleanText.match(/(\d+)\s+STANDART/i) ||
      cleanText.match(/STANDART\s+(\d+)/i);

    if (stdMatch) {
      const multiplier = parseInt(stdMatch[1]);
      log(`STANDART number format detected: ${multiplier} STANDART`);
      distribution['STD'] = multiplier;
      return distribution;
    }

    // OPTIMIZE EDİLMİŞ: İki pattern'i birleştir
    const excludedWords = new Set(['TRY', 'USD', 'EUR', 'GBP', 'ADET', 'KG', 'TL', 'MAL', 'VE', 'BR', 'DIV', 'EM', 'TEK']);
    const validSizes = new Set(['S', 'M', 'L', 'XL', 'XXL', 'XXXL', 'XS', '2XL', '3XL', '4XL', '5XL', '6XL']);

    // YENİ: Kolon formatı - "S:1 M:1 L:1 XL:1 XXL:1" (Romence/Türkçe set bilgisi)
    const colonPattern = /([A-Z]{1,4}|\d{2,3})\s*:\s*(\d+)/gi;
    const colonMatches = [...cleanText.matchAll(colonPattern)];

    if (colonMatches.length > 0) {
      log('Colon format detected');
      for (const match of colonMatches) {
        const sizeName = match[1].toUpperCase();
        const quantity = parseInt(match[2]);
        const isNumericSize = /^\d{2,3}$/.test(sizeName);
        if ((isNumericSize || (validSizes.has(sizeName) && !excludedWords.has(sizeName))) && quantity > 0 && quantity <= 100) {
          distribution[sizeName] = quantity;
          log(`Found colon format: ${sizeName}:${quantity}`);
        }
      }

      if (Object.keys(distribution).length > 0) {
        log('Distribution from colon format:', distribution);
        return distribution;
      }
    }

    // (toserof) Bitişik rakam-önekli beden formatı - "3XL2-4XL1-5XL1-6XL1" (3XL=beden, 2=adet)
    // ERKEN denenir: yoksa "quantity-size" deseni "3XL2"yi yanlış ("3"+"XL") parse eder.
    {
      const dpMatches = [...cleanText.matchAll(/(\d+XL)(\d+)/gi)];
      for (const m of dpMatches) {
        const size = m[1].toUpperCase();
        const quantity = parseInt(m[2]);
        if (validSizes.has(size) && quantity > 0 && quantity <= 100) {
          distribution[size] = quantity;
          log(`Found digit-prefixed size: ${size}${quantity}`);
        }
      }
      if (Object.keys(distribution).length > 0) {
        log('Distribution from digit-prefixed format:', distribution);
        return distribution;
      }
    }

    // YENİ: Parantez formatı - "(S-M)-3" veya "(S-M):3"
    const parenthesisPattern = /\(([A-Z]+(?:-[A-Z]+)*)\)\s*[-:=]\s*(\d+)/gi;
    const parenthesisMatches = [...cleanText.matchAll(parenthesisPattern)];

    if (parenthesisMatches.length > 0) {
      log('Parenthesis format detected');
      for (const match of parenthesisMatches) {
        const sizeName = match[1].toUpperCase();
        const quantity = parseInt(match[2]);
        if (quantity > 0 && quantity <= 100) {
          distribution[sizeName] = quantity;
          log(`Found parenthesis format: (${sizeName})-${quantity}`);
        }
      }

      if (Object.keys(distribution).length > 0) {
        log('Distribution from parenthesis format:', distribution);
        return distribution;
      }
    }

    // YENİ: Tire içeren beden isimleri - "S-M-3" veya "L-XL:2"
    // Önce tire içeren beden isimlerini kontrol et (availableSizes'dan gelecek)
    if (window.productVariantInfo && window.productVariantInfo.allSizes) {
      const availableSizeNames = window.productVariantInfo.allSizes.map(s => s.toUpperCase());
      log('Checking compound size names:', availableSizeNames);

      // Tire içeren beden isimleri varsa onları dene
      for (const sizeName of availableSizeNames) {
        if (sizeName.includes('-')) {
          // "S-M" gibi tire içeren beden için pattern: "S-M-3" veya "S-M:3"
          const escapedSize = sizeName.replace(/-/g, '\\-');
          const compoundPattern = new RegExp(`(${escapedSize})\\s*[-:=]\\s*(\\d+)`, 'gi');
          const compoundMatch = cleanText.match(compoundPattern);

          if (compoundMatch) {
            const qtyMatch = compoundMatch[0].match(/(\d+)$/);
            if (qtyMatch) {
              const quantity = parseInt(qtyMatch[1]);
              if (quantity > 0 && quantity <= 100) {
                distribution[sizeName] = quantity;
                log(`Found compound size: ${sizeName}-${quantity}`);
              }
            }
          }
        }
      }

      if (Object.keys(distribution).length > 0) {
        log('Distribution from compound size names:', distribution);
        return distribution;
      }
    }

    // Önce "2S" gibi quantity-size formatını dene - SADECE GEÇERLİ BEDENLER
    const quantitySizeMatches = cleanText.matchAll(/(\d+)([A-Z]{1,4})/g);
    for (const match of quantitySizeMatches) {
      const quantity = parseInt(match[1]);
      const size = match[2].toUpperCase();
      // SADECE bilinen beden isimleri kabul et
      if (validSizes.has(size) && !excludedWords.has(size) && quantity > 0 && quantity <= 100) {
        distribution[size] = quantity;
        log(`Found quantity-size: ${quantity}${size}`);
      } else {
        log(`Skipped invalid size: ${size} from ${quantity}${size}`);
      }
    }

    if (Object.keys(distribution).length > 0) {
      log('Distribution from quantity-size format:', distribution);
      return distribution;
    }

    // Sonra "S-2" gibi size-quantity formatını dene - GEÇERLİ BEDENLER + NUMERIC
    const sizeQuantityMatches = cleanText.matchAll(/([A-Z]{1,4}|\d{2,3})\s*-\s*(\d{1,2})/gi);
    for (const match of sizeQuantityMatches) {
      const size = match[1].toUpperCase();
      const quantity = parseInt(match[2]);
      const isNumericSize = /^\d{2,3}$/.test(size);
      // Harf bedenler: validSizes kontrolü, Numeric bedenler: direkt kabul
      if ((isNumericSize || (validSizes.has(size) && !excludedWords.has(size))) && quantity > 0 && quantity <= 100) {
        distribution[size] = quantity;
        log(`Found size-quantity: ${size}-${quantity}`);
      } else {
        log(`Skipped invalid size: ${size} from ${size}-${quantity}`);
      }
    }

    if (Object.keys(distribution).length > 0) {
      log('Distribution from size-quantity format:', distribution);
      return distribution;
    }

    // OPTIMIZE EDİLMİŞ: Manual parsing - sadece başarısızlık durumunda
    const parts = cleanText.split(/[\s\-]+/);
    log('Manual parsing parts:', parts);

    for (const part of parts) {
      if (!part) continue;

      // "2S" formatı - SADECE GEÇERLİ BEDENLER
      let match = part.match(/^(\d+)([A-Z]{1,4})$/i);
      if (match) {
        const quantity = parseInt(match[1]);
        const size = match[2].toUpperCase();
        if (validSizes.has(size) && !excludedWords.has(size) && quantity > 0 && quantity <= 100) {
          distribution[size] = quantity;
          log(`Manual quantity-size: ${size} = ${quantity}`);
        }
        continue;
      }

      // "M1" veya "XL2" formatı - beden+adet yapışık
      match = part.match(/^([A-Z]{1,4})(\d{1,2})$/i);
      if (match) {
        const size = match[1].toUpperCase();
        const quantity = parseInt(match[2]);
        const isValid = validSizes.has(size) && !excludedWords.has(size) && quantity > 0 && quantity <= 100;
        if (isValid) {
          distribution[size] = quantity;
          log(`Manual concat size-qty: ${size} = ${quantity}`);
        }
        continue;
      }

      // "S-2" veya "44-2" formatı - GEÇERLİ BEDENLER + NUMERIC
      match = part.match(/^([A-Z]{1,4}|\d{2,3})-(\d{1,2})$/i);
      if (match) {
        const size = match[1].toUpperCase();
        const quantity = parseInt(match[2]);
        const isNumericSize = /^\d{2,3}$/.test(size);
        if ((isNumericSize || (validSizes.has(size) && !excludedWords.has(size))) && quantity > 0 && quantity <= 100) {
          distribution[size] = quantity;
          log(`Manual size-quantity: ${size} = ${quantity}`);
        }
      }
    }

    // AUTO mode - sadece hiçbir şey bulunamazsa
    if (Object.keys(distribution).length === 0 && availableSizes.length > 0) {
      log('No distribution found, using AUTO mode');
      for (const size of availableSizes) {
        const normalizedSize = size.toUpperCase();
        // AUTO mode'da da sadece geçerli bedenleri kabul et
        if (!excludedWords.has(normalizedSize) && validSizes.has(normalizedSize)) {
          distribution[normalizedSize] = 1;
          log(`AUTO: ${normalizedSize} = 1`);
        }
      }
    }

    log('Final distribution:', distribution);
    return distribution;
  }

  function parseVariantDistributions(distributionText) {
    const distributions = {};

    if (!distributionText) return distributions;

    const pairs = distributionText.split(',');

    pairs.forEach(pair => {
      const parts = pair.split('|');
      if (parts.length === 2) {
        const range = parts[0].trim();
        const multiplier = parseInt(parts[1]) || 1;
        distributions[range] = multiplier;
      }
    });

    return distributions;
  }
  function parsePaketYapisi(distributionText) {
    if (!distributionText) return 1;

    const cleanText = cleanupDistributionText(distributionText);
    log('Parsing Paket Yapısı text:', cleanText);

  // "Paket Yapısı: 1S+1M+1L+1XL" formatını parse et
  const paketMatch = cleanText.match(/Paket Yapısı:\s*(.+)/i);
  if (paketMatch) {
    const paketContent = paketMatch[1];
    // '+' ile ayrılmış kısımları say
    const parts = paketContent.split('+');
    const multiplier = parts.length;
    log(`Paket Yapısı detected: ${paketContent} -> multiplier: ${multiplier}`);
    return multiplier;
  }

  return 1;
}
  // STD format için özel stok kontrolü
  function calculateMaxSetsForSTD(stdMultiplier) {
    // STD formatında tek bir variant var, ilk variant'ı kullan
    if (allSizeVariants.length === 0) {
      return {
        maxSets: 0,
        limitingFactor: 'Variant bulunamadı',
        stockDetails: {},
        missingVariants: []
      };
    }

    const variantId = allSizeVariants[0];
    const stockInfo = sizeVariantStocks[variantId];

    if (!stockInfo) {
      return {
        maxSets: 0,
        limitingFactor: 'Stok bilgisi bulunamadı',
        stockDetails: {},
        missingVariants: []
      };
    }

    const availableStock = stockInfo.stock || 0;
    const maxSets = Math.floor(availableStock / stdMultiplier);

    log(`STD Stock Check: ${availableStock} stok / ${stdMultiplier} multiplier = ${maxSets} maksimum set`);

    return {
      maxSets: maxSets,
      limitingFactor: `${availableStock} stok / ${stdMultiplier} multiplier`,
      stockDetails: {
        'STD': {
          required: stdMultiplier,
          available: availableStock,
          variantId: variantId
        }
      },
      missingVariants: []
    };
  }

  // Darboğaz stok kontrolü fonksiyonu
  function calculateMaxSetsFromStock(distribution) {
    const isSTDFormat = Object.keys(distribution).length === 1 && Object.keys(distribution)[0] === 'STD';

    if (isSTDFormat) {
      const stdMultiplier = distribution['STD'];
      return calculateMaxSetsForSTD(stdMultiplier);
    }

    let maxSets = Infinity;
    const stockDetails = {};

    for (const [size, requiredQty] of Object.entries(distribution)) {
      const variantId = findVariantIdBySize(size);

      if (!variantId) {
        log(`Variant not found for size: ${size}`);
        return {
          maxSets: 0,
          limitingFactor: `${size} bedeni bulunamadı`,
          stockDetails: {},
          missingVariants: [size]
        };
      }

      const stockInfo = sizeVariantStocks[variantId];
      const availableStock = stockInfo ? stockInfo.stock : 0;

      stockDetails[size] = {
        required: requiredQty,
        available: availableStock,
        variantId: variantId
      };

      const possibleSets = Math.floor(availableStock / requiredQty);

      if (possibleSets < maxSets) {
        maxSets = possibleSets;
      }

      log(`Size ${size}: ${availableStock} stok / ${requiredQty} gerekli = ${possibleSets} set`);
    }

    const limitingSize = Object.entries(stockDetails).find(([size, info]) =>
      Math.floor(info.available / info.required) === maxSets
    );

    return {
      maxSets: maxSets === Infinity ? 0 : maxSets,
      limitingFactor: limitingSize ? `${limitingSize[0]} bedeni (${limitingSize[1].available} stok)` : 'Bilinmeyen',
      stockDetails: stockDetails,
      missingVariants: []
    };
  }

  // Eksik varyant kontrolü
  function checkMissingVariants(distribution) {
    const missingVariants = [];

    for (const size of Object.keys(distribution)) {
      const variantId = findVariantIdBySize(size);
      if (!variantId) {
        missingVariants.push(size);
      }
    }

    return missingVariants;
  }

  // Set bütünlüğü kontrolü
  function validateSetIntegrity(userQuantity, distribution) {
    const stockAnalysis = calculateMaxSetsFromStock(distribution);
    const missingVariants = checkMissingVariants(distribution);

    const result = {
      isValid: true,
      maxPossibleSets: stockAnalysis.maxSets,
      requestedSets: userQuantity,
      canFulfill: userQuantity <= stockAnalysis.maxSets,
      missingVariants: missingVariants,
      limitingFactor: stockAnalysis.limitingFactor,
      stockDetails: stockAnalysis.stockDetails,
      errors: []
    };

    // Eksik varyant kontrolü
    if (missingVariants.length > 0) {
      result.isValid = false;
      result.errors.push(t('missingSizesErr', { sizes: missingVariants.join(', ') }));
    }

    // Stok yetersizliği kontrolü
    if (userQuantity > stockAnalysis.maxSets) {
      result.isValid = false;
      result.errors.push(t('insufficientStockMaxSetsErr', { max: stockAnalysis.maxSets, factor: stockAnalysis.limitingFactor }));
    }

    log('Set Integrity Check:', result);
    return result;
  }

  // Quantity input'ları maksimum değerle sınırla
  function limitQuantityInputs() {
    if (isBedenSetiFormat) {
      // Beden seti formatında variant bazlı sınırlama
      const selectedVariant = getSelectedVariant();
      if (selectedVariant) {
        const variantSize = getVariantSize(selectedVariant);
        let multiplier = 1;

        for (const [range, rangeMultiplier] of Object.entries(variantDistributions)) {
          if (isSizeInRange(variantSize, range)) {
            multiplier = rangeMultiplier;
            break;
          }
        }

        const stockInfo = sizeVariantStocks[selectedVariant];
        const maxSets = stockInfo ? Math.floor(stockInfo.stock / multiplier) : 0;

        setQuantityInputLimits(maxSets);
      }
    }
    else if (isPaketYapisiFormat) {
      // Paket formatında tek variant var, ilk variant'ı kullan
      if (allSizeVariants.length > 0) {
        const variantId = allSizeVariants[0];
        const stockInfo = sizeVariantStocks[variantId];
        const maxSets = stockInfo ? Math.floor(stockInfo.stock / paketMultiplier) : 0;
        setQuantityInputLimits(maxSets);
      }
    }
   else {
  // Traditional format için set bazlı sınırlama
  const isSTDFormat = Object.keys(sizeDistribution).length === 1 && Object.keys(sizeDistribution)[0] === 'STD';

  if (isSTDFormat) {
    const stdMultiplier = sizeDistribution['STD'];
    log(`STD Format detected: multiplier = ${stdMultiplier}`);

    // STD için özel stok kontrolü
    const stockAnalysis = calculateMaxSetsForSTD(stdMultiplier);
    const maxSets = stockAnalysis.maxSets;

    log(`STD Max sets calculation: ${maxSets} sets allowed`);
    setQuantityInputLimits(maxSets);
  } else {
    const stockAnalysis = calculateMaxSetsFromStock(sizeDistribution);
    setQuantityInputLimits(stockAnalysis.maxSets);
  }
}
  }

  function setQuantityInputLimits(maxValue) {
    const quantitySelectors = [
      'input[name="quantity"]',
      'input[type="number"][name="quantity"]',
      '.quantity-selector input',
      '.quantity__input',
      '.qty',
      '[data-quantity-input]'
    ];

    quantitySelectors.forEach(selector => {
      const inputs = document.querySelectorAll(selector);
      inputs.forEach(input => {
        if (input.type === 'number' || input.type === 'text') {
          input.setAttribute('max', maxValue);

          // Mevcut değer maksimumdan büyükse düzelt
          const currentValue = parseInt(input.value) || 1;
          if (currentValue > maxValue) {
            input.value = Math.max(1, maxValue);

            // Change event'ini tetikle
            const changeEvent = new Event('change', { bubbles: true });
            input.dispatchEvent(changeEvent);
          }

          // SERT ENGELLİ: Input'a manuel yazımı engelle
          if (maxValue === 0) {
            input.value = 0;
            input.disabled = true;
            input.style.backgroundColor = '#f5f5f5';
            input.style.color = '#999';
          } else {
            // Klavye ve mouse ile artırma/azaltmayı engelle
            input.addEventListener('keydown', function (e) {
              // Arrow up ve Page up tuşlarını engelle
              if ((e.key === 'ArrowUp' || e.key === 'PageUp') && parseInt(this.value) >= maxValue) {
                e.preventDefault();
                showQuantityLimitWarning(maxValue);
                return false;
              }
              // Arrow down sadece 1'den küçük olmasını engelle
              if ((e.key === 'ArrowDown' || e.key === 'PageDown') && parseInt(this.value) <= 1) {
                e.preventDefault();
                return false;
              }
            });

            // Mouse wheel ile artırmayı engelle
            input.addEventListener('wheel', function (e) {
              if (e.deltaY < 0 && parseInt(this.value) >= maxValue) { // Wheel up
                e.preventDefault();
                showQuantityLimitWarning(maxValue);
                return false;
              }
            });

            // Manuel yazım kontrolü
            input.addEventListener('input', function (e) {
              let value = parseInt(this.value);
              if (isNaN(value) || value < 1) {
                this.value = 1;
              } else if (value > maxValue) {
                this.value = maxValue;
                showQuantityLimitWarning(maxValue);
              }
            });
          }
        }
      });
    });

    // Plus/minus butonlarını kontrol et
    updateQuantityButtons(maxValue);

    log(`Quantity inputs limited to maximum: ${maxValue} sets`);
  }

  function updateQuantityButtons(maxValue) {
    const currentQuantity = getCurrentQuantity();

    // Plus butonlarını kontrol et - SERT ENGELLİ
    const plusButtons = document.querySelectorAll(
      '[name="plus"], .quantity__button[name="plus"], button[aria-label*="Increase"], .btn-number[data-type="plus"], .quantity-selector button:last-child'
    );

    plusButtons.forEach(btn => {
      if (currentQuantity >= maxValue || maxValue === 0) {
        btn.disabled = true;
        btn.style.opacity = '0.3';
        btn.style.cursor = 'not-allowed';
        btn.style.pointerEvents = 'none';
        btn.title = t('maxSetsOnlyWarn', { max: maxValue });

        // Tüm event listener'ları kaldır
        const newBtn = btn.cloneNode(true);
        btn.parentNode.replaceChild(newBtn, btn);

        // Yeni engelleme event'i ekle
        newBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          showQuantityLimitWarning(maxValue);
          return false;
        });
      } else {
        btn.disabled = false;
        btn.style.opacity = '1';
        btn.style.cursor = 'pointer';
        btn.style.pointerEvents = 'auto';
        btn.title = '';
      }
    });

    // Minus butonlarını kontrol et
    const minusButtons = document.querySelectorAll(
      '[name="minus"], .quantity__button[name="minus"], button[aria-label*="Decrease"], .btn-number[data-type="minus"], .quantity-selector button:first-child'
    );

    minusButtons.forEach(btn => {
      if (currentQuantity <= 1 || maxValue === 0) {
        btn.disabled = true;
        btn.style.opacity = '0.3';
        btn.style.cursor = 'not-allowed';
        btn.style.pointerEvents = 'none';
      } else {
        btn.disabled = false;
        btn.style.opacity = '1';
        btn.style.cursor = 'pointer';
        btn.style.pointerEvents = 'auto';
      }
    });
  }

  // Sınır uyarısı göster
  function showQuantityLimitWarning(maxValue) {
  // Mevcut uyarıyı kaldır
  const existingWarning = document.querySelector('.quantity-limit-warning');
  if (existingWarning) {
    existingWarning.remove();
  }

  const warning = document.createElement('div');
  warning.className = 'quantity-limit-warning';
  warning.style.cssText = `
    position: fixed;
    top: 20px;
    right: 20px;
    background: linear-gradient(135deg, #ff6b6b 0%, #ff8e8e 100%);
    color: white;
    padding: 12px 20px;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(255, 107, 107, 0.3);
    z-index: 99999;
    animation: slideInShake 0.5s ease-out;
    font-size: 14px;
    font-weight: 500;
    max-width: 300px;
    display: flex;
    align-items: center;
    gap: 10px;
  `;

  const isSTDFormat = Object.keys(sizeDistribution).length === 1 && Object.keys(sizeDistribution)[0] === 'STD';
  let message;

  if (maxValue === 0) {
    if (isPaketYapisiFormat) {
      message = t('pkgInsufficientWarn');
    } else if (isSTDFormat) {
      message = t('stdInsufficientWarn');
    } else {
      message = t('setIntegrityWarn');
    }
  } else {
    let multiplier = 1;
    if (isPaketYapisiFormat) {
      multiplier = paketMultiplier;
    } else if (isSTDFormat) {
      multiplier = sizeDistribution['STD'];
    }
    const totalItems = maxValue * multiplier;
    const formatType = isPaketYapisiFormat ? t('pkgUnit') : t('setUnit');
    message = t('maxAddableWarn', { max: maxValue, format: formatType, total: totalItems });
  }

  warning.innerHTML = `
    <span style="font-size: 18px;">⚠️</span>
    <span>${message}</span>
  `;

  document.body.appendChild(warning);

  // 3 saniye sonra kaldır
  setTimeout(() => {
    if (warning.parentNode) {
      warning.style.animation = 'slideOutShake 0.3s ease-in';
      setTimeout(() => warning.remove(), 300);
    }
  }, 3000);
}

  // ============================================================
  // toserof: SET TOPLAM FİYATI + SEPETE-EKLENİYOR BEKLETME
  // Ana/varyant fiyatı BİRİM (tane başı) fiyatıdır. Set eklenince N parça
  // sepete girer; bu yüzden fiyatın ALTINA "Set toplamı = birim × N" yazılır.
  // (Hasan Bey talebi: "ana fiyat x set adedi", çarparak — bölerek DEĞİL.)
  // ============================================================
  function stParsePrice(text) {
    if (!text) return null;
    const m = text.match(/\d{1,3}(?:[.,\s]\d{3})+(?:[.,]\d{1,2})?|\d+(?:[.,]\d{1,2})?/);
    if (!m) return null;
    const token = m[0];
    const lastComma = token.lastIndexOf(','), lastDot = token.lastIndexOf('.');
    let decSep = null, thoSep = null;
    if (lastComma > -1 && lastDot > -1) {
      if (lastComma > lastDot) { decSep = ','; thoSep = '.'; } else { decSep = '.'; thoSep = ','; }
    } else if (lastComma > -1) {
      if ((token.length - lastComma - 1) <= 2) decSep = ','; else thoSep = ',';
    } else if (lastDot > -1) {
      if ((token.length - lastDot - 1) <= 2) decSep = '.'; else thoSep = '.';
    }
    let norm = token.replace(/\s/g, '');
    if (thoSep) norm = norm.split(thoSep).join('');
    if (decSep) norm = norm.replace(decSep, '.');
    const value = parseFloat(norm);
    if (!isFinite(value)) return null;
    const cm = text.match(/₺|€|\$|£|lei|RON|TL|EUR|USD|GBP/i);
    return {
      value,
      decSep: decSep || ',',
      thoSep: thoSep || ((decSep === ',') ? '.' : ','),
      cur: cm ? cm[0] : '',
      curBefore: cm ? (cm.index < m.index) : false
    };
  }
  function stFormatPrice(total, fmt) {
    const fixed = (Math.round(total * 100) / 100).toFixed(2);
    let parts = fixed.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, fmt.thoSep);
    const numStr = parts[0] + fmt.decSep + parts[1];
    if (!fmt.cur) return numStr;
    const symbolCur = /^[₺€$£]$/.test(fmt.cur);
    return fmt.curBefore ? (symbolCur ? `${fmt.cur}${numStr}` : `${fmt.cur} ${numStr}`) : `${numStr} ${fmt.cur}`;
  }
  // O anki formata göre set BAŞINA parça adedi (fiyat çarpanı)
  function stCurrentPiecesPerSet() {
    try {
      if (isBedenSetiFormat) {
        const sv = getSelectedVariant();
        if (!sv) return 0;
        const size = getVariantSize(sv);
        for (const [range, mult] of Object.entries(variantDistributions)) {
          if (isSizeInRange(size, range)) return mult;
        }
        return 0;
      }
      if (isPaketYapisiFormat) return paketMultiplier || 0;
      return Object.values(sizeDistribution).reduce((s, q) => s + q, 0) || 0;
    } catch (e) { return 0; }
  }
  function stGetPriceElement() {
    const sels = ['.price:not(.price--sold-out)', '.product-price', '.product__price', '.product-form__price', '[data-price]', '[data-product-price]', '.price-item--regular', '.price-item', '.money', '.price-wrapper', '.product-price-wrapper'];
    for (const s of sels) {
      const els = document.querySelectorAll(s);
      for (const el of els) {
        const r = el.getBoundingClientRect();
        if (r.width > 0 && r.height > 0 && /\d/.test(el.textContent)) return el;
      }
    }
    return null;
  }
  let stPriceObserver = null;
  function stEnsureTotalEl(priceEl) {
    let el = document.getElementById('setTotalPrice');
    if (!el) {
      el = document.createElement('div');
      el.id = 'setTotalPrice';
      el.className = 'set-total-price';
      priceEl.parentNode.insertBefore(el, priceEl.nextSibling);
    }
    return el;
  }
  function updateSetTotalPrice() {
    try {
      const priceEl = stGetPriceElement();
      if (!priceEl) return;
      const el = stEnsureTotalEl(priceEl);
      const pieces = stCurrentPiecesPerSet();
      if (!pieces || pieces <= 1) { el.style.display = 'none'; return; }
      const parsed = stParsePrice(priceEl.textContent);
      if (!parsed) { el.style.display = 'none'; return; }
      const total = parsed.value * pieces;
      el.style.display = '';
      el.innerHTML =
        `<span class="set-total-price__label">${t('setTotalLabel')}</span> ` +
        `<span class="set-total-price__value">${stFormatPrice(total, parsed)}</span> ` +
        `<span class="set-total-price__note">${parsed.value ? stFormatPrice(parsed.value, parsed) + ' ' + t('unitPriceNote') + ' × ' : ''}${pieces} ${t('pcsUnit')}</span>`;
      if (!stPriceObserver) {
        stPriceObserver = new MutationObserver(() => updateSetTotalPrice());
        stPriceObserver.observe(priceEl, { childList: true, characterData: true, subtree: true });
      }
    } catch (e) { log('updateSetTotalPrice error: ' + e.message); }
  }

  // Sepete eklenirken buton + bilgi şeridiyle müşteriyi bekletme
  function stSetAddLoading(on) {
    try {
      document.querySelectorAll('form[action*="/cart/add"], .product-form').forEach(f => {
        f.querySelectorAll('[name="add"], .product-form__submit, button[type="submit"]').forEach(btn => {
          if (on) { btn.classList.add('st-btn-loading'); btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
          else { btn.classList.remove('st-btn-loading'); btn.removeAttribute('aria-busy'); btn.disabled = false; }
        });
      });
      let n = document.getElementById('stAddingNotice');
      if (on) {
        if (!n) {
          n = document.createElement('div');
          n.id = 'stAddingNotice';
          n.className = 'st-adding-notice';
          n.setAttribute('role', 'status');
          n.innerHTML = `<span class="st-adding-spinner"></span><span>${t('addingToCartOverlay')}</span>`;
          const form = document.querySelector('form[action*="/cart/add"], .product-form');
          (form || document.body).appendChild(n);
        }
        n.style.display = 'flex';
      } else if (n) { n.style.display = 'none'; }
    } catch (e) { log('stSetAddLoading error: ' + e.message); }
  }

  function moveSetInfoToCorrectPosition() {
    const setInfoElement = document.getElementById('setMultiplierInfo');
    if (!setInfoElement) {
      log('Set info element not found, will be created later');
      return;
    }

    const priceSelectors = [
      '.price:not(.price--sold-out)',
      '.product-price',
      '.product__price',
      '.product-form__price',
      '[data-price]',
      '[data-product-price]',
      '.money',
      '.price-item',
      '.price-wrapper',
      '.product-price-wrapper'
    ];

    let priceElement = null;

    for (const selector of priceSelectors) {
      const elements = document.querySelectorAll(selector);
      if (elements.length > 0) {
        priceElement = Array.from(elements).find(el => {
          const rect = el.getBoundingClientRect();
          return rect.width > 0 && rect.height > 0;
        });
        if (priceElement) {
          log(`Found price element with selector: ${selector}`);
          break;
        }
      }
    }

    if (!priceElement) {
      const productForm = document.querySelector('form[action*="/cart/add"], .product-form');
      if (productForm) {
        priceElement = productForm.querySelector('.price, [class*="price"]');
        if (priceElement) {
          log('Found price element in product form');
        }
      }
    }

    if (priceElement) {
      priceElement.parentNode.insertBefore(setInfoElement, priceElement.nextSibling);
      log('Set info moved to position after price element');
    } else {
      log('Price element not found, keeping set info in original position');
      const productForm = document.querySelector('form[action*="/cart/add"], .product-form');
      if (productForm) {
        productForm.appendChild(setInfoElement);
        log('Set info moved to end of product form');
      }
    }

    // toserof: fiyatın altına set toplamını bas + varyant değişiminde güncelle
    updateSetTotalPrice();
    const pForm = document.querySelector('form[action*="/cart/add"], .product-form');
    if (pForm && !pForm.dataset.stTotalBound) {
      pForm.dataset.stTotalBound = '1';
      pForm.addEventListener('change', () => setTimeout(updateSetTotalPrice, 60));
    }
  }

  function updateSetInfoDisplay() {
    const setInfoText = document.getElementById('setInfoText');
    const setInfoDetails = document.getElementById('setInfoDetails');

    if (!setInfoText || !setInfoDetails) return;

    if (isBedenSetiFormat) {
      setInfoText.innerHTML = `<strong>${t('bedenSetiTitle')}</strong> ${t('bedenSetiAutoDesc')}`;

      let detailsHtml = '<div style="margin-top: 5px;">';
      for (const [range, multiplier] of Object.entries(variantDistributions)) {
        detailsHtml += `<div style="margin: 2px 0;">${t('rangeNotice', { range: range, qty: multiplier })}</div>`;
      }
      detailsHtml += '</div>';
      setInfoDetails.innerHTML = detailsHtml;

    }
    else if (isPaketYapisiFormat) {
      setInfoText.innerHTML = `<strong>${t('paketTitle')}</strong> ${t('paketDescription', { qty: paketMultiplier })}`;
      setInfoDetails.innerHTML = `<div style="margin-top: 5px; color: #666;"><small>${t('paketSubtitle')}</small></div>`;
    }
    else {
      const totalItems = Object.values(sizeDistribution).reduce((sum, qty) => sum + qty, 0);

      const isSTDFormat = Object.keys(sizeDistribution).length === 1 && Object.keys(sizeDistribution)[0] === 'STD';

      if (isSTDFormat) {
        setInfoText.innerHTML = `<strong>${t('setTitle')}</strong> ${t('setStdDescription', { qty: totalItems })}`;
        setInfoDetails.innerHTML = `<div style="margin-top: 5px; color: #666;"><small>${t('setSubtitle')}</small></div>`;
      } else {
        // Stok analizi ekle
        const stockAnalysis = calculateMaxSetsFromStock(sizeDistribution);

        setInfoText.innerHTML = `<strong>${t('setTitle')}</strong> ${t('setMultiDescription', { qty: totalItems })}`;

        let detailsHtml = `<div style="margin-top: 5px;"><strong>${t('distributionLabel')}</strong> `;
        const distributionParts = [];
        for (const [size, qty] of Object.entries(sizeDistribution)) {
          distributionParts.push(`${size} (${qty} ${t('pcsUnit')})`);
        }
        detailsHtml += distributionParts.join(', ') + '</div>';

        // Maksimum set bilgisi ekle
        detailsHtml += `<div style="margin-top: 8px; padding: 6px; background: #e8f5e8; border-radius: 4px; border-left: 3px solid #4caf50;">
          <strong>${t('maxAddableLabel')}</strong> ${stockAnalysis.maxSets} ${t('setUnit')}
          ${stockAnalysis.maxSets > 0 ? `<br><small>${t('limitingFactorLabel')} ${stockAnalysis.limitingFactor}</small>` : ''}
        </div>`;

        setInfoDetails.innerHTML = detailsHtml;
      }
    }
  }

  function getCurrentQuantity() {
    const quantitySelectors = [
      'input[name="quantity"]',
      'input[type="number"][name="quantity"]',
      '.quantity-selector input',
      '.quantity__input',
      '.qty',
      '[data-quantity-input]'
    ];

    for (const selector of quantitySelectors) {
      const input = document.querySelector(selector);
      if (input && input.value) {
        const value = parseInt(input.value) || 1;
        log(`Found quantity input: ${selector} = ${value}`);
        return Math.max(1, value);
      }
    }

    log('No quantity input found, defaulting to 1');
    return 1;
  }

  function updateSetInfoOnQuantityChange(quantity) {
    const setInfoDetails = document.getElementById('setInfoDetails');
    if (!setInfoDetails) return;

    quantity = Math.max(1, parseInt(quantity) || 1);

    // Maksimum sınırları kontrol et ve güncelle
    limitQuantityInputs();

    if (isBedenSetiFormat) {
      const selectedVariant = getSelectedVariant();
      if (selectedVariant) {
        const variantSize = getVariantSize(selectedVariant);
        let selectedRange = null;
        let multiplier = 1;

        for (const [range, rangeMultiplier] of Object.entries(variantDistributions)) {
          if (isSizeInRange(variantSize, range)) {
            selectedRange = range;
            multiplier = rangeMultiplier;
            break;
          }
        }

        if (selectedRange) {
          const finalQuantity = quantity * multiplier;
          const stockInfo = sizeVariantStocks[selectedVariant];
          const maxSets = stockInfo ? Math.floor(stockInfo.stock / multiplier) : 0;

          setInfoDetails.innerHTML = `<div style="margin-top: 5px; padding: 8px; background: #e8f4f8; border-radius: 4px; border: 1px solid #007cba;">
            <strong>${t('yourSelectionLabel')}</strong> ${selectedRange} → ${quantity} × ${multiplier} = <span style="color: #007cba; font-weight: bold;">${finalQuantity} ${t('pcsUnit')}</span>
            <div style="margin-top: 4px; font-size: 12px; color: #666;">
              ${t('maxAddableLabel')} ${maxSets} ${t('setUnit')} (${maxSets * multiplier} ${t('pcsUnit')})
            </div>
          </div>`;
        }
      }
    }
    else if (isPaketYapisiFormat) {
      const finalTotal = quantity * paketMultiplier;
      const variantId = allSizeVariants[0];
      const stockInfo = sizeVariantStocks[variantId];
      const maxSets = stockInfo ? Math.floor(stockInfo.stock / paketMultiplier) : 0;

      setInfoDetails.innerHTML = `<div style="margin-top: 5px; padding: 8px; background: #e8f4f8; border-radius: 4px; border: 1px solid #007cba;">
    <strong>${t('addingToCartLabel')}</strong> ${quantity} ${t('pkgUnit')} × ${paketMultiplier} = <span style="color: #007cba; font-weight: bold;">${finalTotal} ${t('pcsUnit')}</span>
    <div style="margin-top: 4px; font-size: 12px; color: #666;">
      ${t('maxAddableLabel')} ${maxSets} ${t('pkgUnitPlural')} (${maxSets * paketMultiplier} ${t('pcsUnit')})
    </div>
  </div>`;
    }
    else {
      const totalPerSet = Object.values(sizeDistribution).reduce((sum, qty) => sum + qty, 0);
      const finalTotal = quantity * totalPerSet;

      const isSTDFormat = Object.keys(sizeDistribution).length === 1 && Object.keys(sizeDistribution)[0] === 'STD';

      if (isSTDFormat) {
        const stdQuantity = sizeDistribution['STD'];
        const variantId = allSizeVariants[0];
        const stockInfo = sizeVariantStocks[variantId];
        const maxSets = stockInfo ? Math.floor(stockInfo.stock / stdQuantity) : 0;

        setInfoDetails.innerHTML = `<div style="margin-top: 5px; padding: 8px; background: #e8f4f8; border-radius: 4px; border: 1px solid #007cba;">
          <strong>${t('addingToCartLabel')}</strong> ${quantity} ${t('pcsUnit')} × ${totalPerSet} = <span style="color: #007cba; font-weight: bold;">${finalTotal} ${t('pcsUnit')}</span>
          <div style="margin-top: 4px; font-size: 12px; color: #666;">
            ${t('maxAddableLabel')} ${maxSets} ${t('setUnit')} (${maxSets * totalPerSet} ${t('pcsUnit')})
          </div>
        </div>`;
      } else {
        // Set doğrulama ve stok kontrolü
        const validation = validateSetIntegrity(quantity, sizeDistribution);

        let detailsHtml = `<div style="margin-top: 5px; padding: 8px; background: ${validation.isValid ? '#e8f4f8' : '#ffe8e8'}; border-radius: 4px; border: 1px solid ${validation.isValid ? '#007cba' : '#ff6b6b'};">`;

        if (validation.isValid) {
          detailsHtml += `<strong>${t('addingToCartLabel')}</strong> ${quantity} ${t('setUnit')} × ${totalPerSet} ${t('pcsUnit')} = <span style="color: #007cba; font-weight: bold;">${finalTotal} ${t('pcsUnit')}</span><br>
            <small style="color: #666;">${t('detailsLabel')} `;

          const details = [];
          for (const [size, qty] of Object.entries(sizeDistribution)) {
            const sizeTotal = qty * quantity;
            details.push(`${size}: ${sizeTotal} ${t('pcsUnit')}`);
          }
          detailsHtml += details.join(', ') + '</small>';

          // Maksimum bilgisi ekle
          detailsHtml += `<br><small style="color: #666; margin-top: 4px; display: block;">
            ${t('maxAddableLabel')} ${validation.maxPossibleSets} ${t('setUnit')} (${validation.maxPossibleSets * totalPerSet} ${t('pcsUnit')})
          </small>`;
        } else {
          detailsHtml += `<strong style="color: #ff6b6b;">${t('cantAddTitle')}</strong><br>`;
          validation.errors.forEach(error => {
            detailsHtml += `<small style="color: #ff6b6b;">• ${error}</small><br>`;
          });
          detailsHtml += `<small style="color: #666;">${t('maxAddableLabel')} ${validation.maxPossibleSets} ${t('setUnit')}</small>`;
        }

        detailsHtml += '</div>';
        setInfoDetails.innerHTML = detailsHtml;
      }
    }

    // toserof: set toplam fiyatını da tazele (varyant/miktar etkileşimi sonrası)
    updateSetTotalPrice();
  }

  function getSelectedVariant() {
    const variantSelect = document.querySelector('select[name="id"]');
    if (variantSelect) {
      return variantSelect.value;
    }

    const checkedVariant = document.querySelector('input[name="id"]:checked');
    if (checkedVariant) {
      return checkedVariant.value;
    }

    const variantInput = document.querySelector('input[name="id"]');
    if (variantInput) {
      return variantInput.value;
    }

    return null;
  }

  function setupQuantityListener() {
    const quantitySelectors = [
      'input[name="quantity"]',
      'input[type="number"][name="quantity"]',
      '.quantity-selector input',
      '.quantity__input',
      '.qty',
      '[data-quantity-input]'
    ];

    quantitySelectors.forEach(selector => {
      const inputs = document.querySelectorAll(selector);
      inputs.forEach(input => {
        ['input', 'change', 'keyup', 'blur'].forEach(eventType => {
          input.addEventListener(eventType, (e) => {
            // OPTIMIZE EDİLMİŞ: Debounce ile tekrar eden event'leri engelle
            debounce('quantityChange', () => {
              let quantity = parseInt(e.target.value) || 1;

              // Maximum değeri kontrol et
              const maxValue = parseInt(e.target.getAttribute('max'));
              if (maxValue && quantity > maxValue) {
                quantity = maxValue;
                e.target.value = maxValue;
                showQuantityLimitWarning(maxValue);
              }

              // Minimum 1 olması gerekiyor (max 0 değilse)
              if (quantity < 1 && maxValue !== 0) {
                quantity = 1;
                e.target.value = 1;
              }

              log(`Quantity changed via ${eventType}: ${quantity}`);
              updateSetInfoOnQuantityChange(quantity);
            }, 200);
          });
        });
      });
    });

    const variantSelectors = document.querySelectorAll('select[name="id"], input[name="id"]');
    variantSelectors.forEach(selector => {
      selector.addEventListener('change', () => {
        const currentQuantity = getCurrentQuantity();
        log(`Variant changed, updating with quantity: ${currentQuantity}`);

        // Variant değiştiğinde sınırları yeniden hesapla
        limitQuantityInputs();
        updateSetInfoOnQuantityChange(currentQuantity);
      });
    });

    // Plus/minus butonları için SERT event listener'lar
    const plusButtons = document.querySelectorAll(
      '[name="plus"], .quantity__button[name="plus"], button[aria-label*="Increase"], .btn-number[data-type="plus"], .quantity-selector button:last-child'
    );

    plusButtons.forEach(btn => {
      // Tüm mevcut event listener'ları kaldır
      const newBtn = btn.cloneNode(true);
      btn.parentNode.replaceChild(newBtn, btn);

      newBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();

        const quantityInput = document.querySelector('input[name="quantity"]') ||
          e.target.parentNode.querySelector('input[name="quantity"], input[type="number"]');

        if (quantityInput) {
          const currentValue = parseInt(quantityInput.value) || 1;
          const maxValue = parseInt(quantityInput.getAttribute('max')) || Infinity;

          if (currentValue < maxValue && maxValue > 0) {
            const newValue = currentValue + 1;
            quantityInput.value = newValue;

            const changeEvent = new Event('change', { bubbles: true });
            quantityInput.dispatchEvent(changeEvent);
          } else {
            showQuantityLimitWarning(maxValue);
          }
        }

        return false;
      });
    });

    const minusButtons = document.querySelectorAll(
      '[name="minus"], .quantity__button[name="minus"], button[aria-label*="Decrease"], .btn-number[data-type="minus"], .quantity-selector button:first-child'
    );

    minusButtons.forEach(btn => {
      // Tüm mevcut event listener'ları kaldır
      const newBtn = btn.cloneNode(true);
      btn.parentNode.replaceChild(newBtn, btn);

      newBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();

        const quantityInput = document.querySelector('input[name="quantity"]') ||
          e.target.parentNode.querySelector('input[name="quantity"], input[type="number"]');

        if (quantityInput) {
          const currentValue = parseInt(quantityInput.value) || 1;
          const maxValue = parseInt(quantityInput.getAttribute('max')) || Infinity;

          if (currentValue > 1 && maxValue > 0) {
            const newValue = currentValue - 1;
            quantityInput.value = newValue;

            const changeEvent = new Event('change', { bubbles: true });
            quantityInput.dispatchEvent(changeEvent);
          }
        }

        return false;
      });
    });

    const observer = new MutationObserver((mutations) => {
      // OPTIMIZE EDİLMİŞ: Debounce ile tekrarlayan çağrıları engelle
      debounce('mutationObserver', () => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList') {
            mutation.addedNodes.forEach((node) => {
              if (node.nodeType === 1) {
                const quantityInputs = node.querySelectorAll ? node.querySelectorAll(quantitySelectors.join(',')) : [];
                quantityInputs.forEach(input => {
                  ['input', 'change'].forEach(eventType => {
                    input.addEventListener(eventType, (e) => {
                      let quantity = parseInt(e.target.value) || 1;

                      // Maximum değeri kontrol et
                      const maxValue = parseInt(e.target.getAttribute('max'));
                      if (maxValue && quantity > maxValue) {
                        quantity = maxValue;
                        e.target.value = maxValue;
                        showQuantityLimitWarning(maxValue);
                      }

                      updateSetInfoOnQuantityChange(quantity);
                    });
                  });
                });
              }
            });
          }
        });
      }, 500);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Başlangıçta maksimum sınırları uygula
    setTimeout(() => {
      limitQuantityInputs();
    }, 100);
  }

  function normalizeSize(size) {
    return size.toString().toUpperCase().trim().replace(/[.\s]+$/, '');
  }

  function findVariantIdBySize(targetSize) {
    const normalizedTarget = normalizeSize(targetSize);
    log(`🔍 Searching for variant with size: "${targetSize}" (normalized: "${normalizedTarget}")`);

    if (normalizedTarget === 'STD') {
      if (allSizeVariants.length > 0) {
        log('✓ STD format: Using first available variant:', allSizeVariants[0]);
        return allSizeVariants[0];
      }
    }

    // Önce TAM EŞLEŞMEyE BAK - tire içeren beden isimleri için
    log('📦 Checking sizeVariantStocks:', Object.keys(sizeVariantStocks).length, 'variants');
    for (const variantId in sizeVariantStocks) {
      const sizeInfo = sizeVariantStocks[variantId];
      const sizeName = normalizeSize(sizeInfo.sizeName);
      log(`  - Variant ${variantId}: sizeName="${sizeInfo.sizeName}" (normalized: "${sizeName}")`);
      if (sizeName === normalizedTarget) {
        log(`✓ Found variant ${variantId} for size ${targetSize} (exact match)`);
        return variantId;
      }
    }

    // Sonra availableSizes'ta ara
    log('📋 Checking availableSizes:', availableSizes);
    for (let i = 0; i < availableSizes.length; i++) {
      const availableSize = normalizeSize(availableSizes[i]);
      log(`  - Index ${i}: "${availableSizes[i]}" (normalized: "${availableSize}")`);
      if (availableSize === normalizedTarget && i < allSizeVariants.length) {
        log(`✓ Found variant ${allSizeVariants[i]} for size ${targetSize} at index ${i} (exact match)`);
        return allSizeVariants[i];
      }
    }

    // YENİ: Kısmi eşleşme - tire içeren beden isimleri için
    // Örnek: "XL" arıyoruz, "L-XL" varyantını bulabiliriz
    log('🔍 Trying partial match for compound sizes...');
    for (const variantId in sizeVariantStocks) {
      const sizeInfo = sizeVariantStocks[variantId];
      const sizeName = normalizeSize(sizeInfo.sizeName);

      // Tire içeren beden ismi mi?
      if (sizeName.includes('-')) {
        const sizeParts = sizeName.split('-').map(s => s.trim());
        log(`  - Checking compound size "${sizeName}": parts = [${sizeParts.join(', ')}]`);

        // Aranan beden, bileşenlerden biri mi?
        if (sizeParts.includes(normalizedTarget)) {
          log(`✓ Found variant ${variantId} for size ${targetSize} (partial match in "${sizeName}")`);
          return variantId;
        }
      }
    }

    // availableSizes'ta da kısmi eşleşme dene
    for (let i = 0; i < availableSizes.length; i++) {
      const availableSize = normalizeSize(availableSizes[i]);

      if (availableSize.includes('-')) {
        const sizeParts = availableSize.split('-').map(s => s.trim());

        if (sizeParts.includes(normalizedTarget) && i < allSizeVariants.length) {
          log(`✓ Found variant ${allSizeVariants[i]} for size ${targetSize} at index ${i} (partial match in "${availableSize}")`);
          return allSizeVariants[i];
        }
      }
    }

    logError(`❌ Variant NOT found for size: "${targetSize}" (normalized: "${normalizedTarget}")`);
    logError('Available sizeVariantStocks keys:', Object.keys(sizeVariantStocks));
    logError('Available sizes:', availableSizes);
    return null;
  }

  // CSS animasyonları ekle
  function addQuantityLimitStyles() {
    if (document.querySelector('#quantity-limit-styles')) return;

    const style = document.createElement('style');
    style.id = 'quantity-limit-styles';
    style.textContent = `
      @keyframes slideInShake {
        0% { 
          transform: translateX(100%) scale(0.8);
          opacity: 0;
        }
        50% {
          transform: translateX(-10px) scale(1.05);
          opacity: 1;
        }
        60% {
          transform: translateX(5px) scale(1.02);
        }
        70% {
          transform: translateX(-3px) scale(1.01);
        }
        100% { 
          transform: translateX(0) scale(1);
          opacity: 1;
        }
      }
      @keyframes slideOutShake {
        0% { 
          transform: translateX(0) scale(1);
          opacity: 1;
        }
        100% { 
          transform: translateX(100%) scale(0.8);
          opacity: 0;
        }
      }
      
      .quantity-limit-warning {
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
      }
      
      /* Disabled buton efektleri */
      button:disabled.quantity-disabled {
        background: #f5f5f5 !important;
        color: #ccc !important;
        cursor: not-allowed !important;
        pointer-events: none !important;
        opacity: 0.3 !important;
        transform: none !important;
      }
      
      /* Input disabled efektleri */
      input:disabled.quantity-disabled {
        background: #f5f5f5 !important;
        color: #999 !important;
        cursor: not-allowed !important;
        border-color: #ddd !important;
      }

      /* ===== toserof: SET TOPLAM FİYATI (fiyatın altında) ===== */
      .set-total-price {
        margin-top: 4px;
        font-size: 14px;
        line-height: 1.35;
        color: #151515;
      }
      .set-total-price__label { font-weight: 400; opacity: .85; }
      .set-total-price__value { font-weight: 700; }
      .set-total-price__note {
        display: inline-block;
        margin-left: 6px;
        font-size: 12px;
        color: #6b7280;
      }

      /* ===== toserof: SEPETE EKLENİYOR bekletme ===== */
      .st-btn-loading {
        position: relative !important;
        color: transparent !important;
        pointer-events: none !important;
        opacity: 1 !important;
      }
      .st-btn-loading > * { visibility: hidden !important; }
      .st-btn-loading::after {
        content: '';
        position: absolute;
        top: 50%; left: 50%;
        width: 20px; height: 20px;
        margin: -10px 0 0 -10px;
        border: 2px solid rgba(255, 255, 255, .35);
        border-top-color: #fff;
        border-radius: 50%;
        animation: st-spin .7s linear infinite;
        visibility: visible !important;
      }
      .st-adding-notice {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-top: 12px;
        padding: 10px 14px;
        background: #f8f9fa;
        border: 1px solid #e5e7eb;
        border-left: 4px solid #007cba;
        border-radius: 6px;
        font-size: 14px;
        color: #151515;
        animation: st-fade .25s ease;
      }
      .st-adding-spinner {
        flex: none;
        width: 16px; height: 16px;
        border: 2px solid rgba(0, 0, 0, .15);
        border-top-color: #007cba;
        border-radius: 50%;
        animation: st-spin .7s linear infinite;
      }
      @keyframes st-spin { to { transform: rotate(360deg); } }
      @keyframes st-fade { from { opacity: 0; transform: translateY(-4px); } to { opacity: 1; transform: none; } }
    `;
    document.head.appendChild(style);
  }

  function forceMultiplier() {
    if (isInitialized) return;
    isInitialized = true;

    if (!initializeMultiplier()) {
      logError('Set multiplier initialization failed');
      return;
    }

    // CSS stilleri ekle
    addQuantityLimitStyles();

    // Debug: Başlangıç bilgilerini logla
    log('=== INITIALIZATION DEBUG ===');
    log('Size distribution:', sizeDistribution);
    log('Size variant stocks:', sizeVariantStocks);
    log('All size variants:', allSizeVariants);
    log('Is STD format:', Object.keys(sizeDistribution).length === 1 && Object.keys(sizeDistribution)[0] === 'STD');

    if (Object.keys(sizeDistribution).length === 1 && Object.keys(sizeDistribution)[0] === 'STD') {
      const stdMultiplier = sizeDistribution['STD'];
      const stockAnalysis = calculateMaxSetsForSTD(stdMultiplier);
      log('STD Stock Analysis:', stockAnalysis);
    }
    log('=== END DEBUG ===');

    const originalFetch = window.fetch;
    let interceptorApplied = false;

    if (!interceptorApplied) {
      window.fetch = async function (url, options = {}) {
        if (options.headers && options.headers[internalRequestFlag]) {
          delete options.headers[internalRequestFlag];
          return originalFetch.call(this, url, options);
        }

        if (typeof url === 'string' && url.includes('/cart/add')) {
          return handleSetCartRequest(originalFetch, url, options);
        }

        return originalFetch.call(this, url, options);
      };
      interceptorApplied = true;
      log('Fetch interceptor applied');
    }

    setTimeout(() => {
      setupQuantityListener();
      moveSetInfoToCorrectPosition();
      const initialQuantity = getCurrentQuantity();
      log(`Updating with initial quantity: ${initialQuantity}`);
      updateSetInfoOnQuantityChange(initialQuantity);
    }, 500);

    log('Set Multiplier active');
  }

  async function handleSetCartRequest(originalFetch, url, options) {
    const requestSignature = createRequestSignature(options.body);

    if (processedRequests.has(requestSignature)) {
      return new Response(JSON.stringify({
        status: 'success',
        message: 'Request already processed',
        duplicate: true
      }), {
        status: 200,
        headers: { 'Content-Type': 'application/json' }
      });
    }

    processedRequests.add(requestSignature);

    if (isProcessingRequest) {
      return new Response(JSON.stringify({
        status: 'success',
        message: t('setProcessingMsg'),
        processing: true
      }), {
        status: 200,
        headers: { 'Content-Type': 'application/json' }
      });
    }

    isProcessingRequest = true;
    stSetAddLoading(true); // toserof: sepete eklenirken bekletme

    try {
      const userQuantity = getQuantityFromData(options.body);
      let addResults;

      if (isBedenSetiFormat) {
        const selectedVariantId = getVariantIdFromData(options.body);
        addResults = await addBedenSetiToCart(originalFetch, userQuantity, selectedVariantId, url, options);
      } else {
        addResults = await addTraditionalSetToCart(originalFetch, userQuantity, url, options);
      }

      if (addResults.success) {
        setTimeout(() => {
          triggerCartEvents({ item_count: addResults.totalAdded });
        }, 100);

        setTimeout(() => updateCartCount(), 300);

        setTimeout(() => {
          updateCartDrawer();
        }, 500);

        const formatInfo = isBedenSetiFormat ? t('formatSetSize') :
          isPaketYapisiFormat ? t('formatPackage') : t('formatSet');
        return new Response(JSON.stringify({
          status: 'success',
          message: t('productsAddedMsg', { qty: userQuantity, formatInfo: formatInfo, total: addResults.totalAdded }),
          details: addResults.details,
          format: isBedenSetiFormat ? 'beden_seti' :
            isPaketYapisiFormat ? 'paket_yapisi' : 'traditional', id: Date.now(),
          quantity: addResults.totalAdded,
          variant_id: 'multiple',
          line_price: 0,
          sections: {
            'cart-drawer': '<div>Updated cart content</div>',
            'cart-icon-bubble': `<span>${addResults.totalAdded}</span>`
          }
        }), {
          status: 200,
          headers: { 'Content-Type': 'application/json' }
        });
      } else {
        logError('Set adding failed:', addResults.errors);

        // Hata mesajını kullanıcıya göster
        return new Response(JSON.stringify({
          status: 'error',
          message: addResults.errors.join('\n'),
          description: t('cantAddIntegrityMsg')
        }), {
          status: 422,
          headers: { 'Content-Type': 'application/json' }
        });
      }

    } catch (error) {
      logError('Set request error:', error);
      return originalFetch.call(this, url, options);

    } finally {
      stSetAddLoading(false); // toserof: bekletmeyi kaldır
      // İşlem bayrağını hemen sıfırla (daha responsive olması için)
      setTimeout(() => {
        isProcessingRequest = false;
      }, 100);

      // Request signature'ı biraz sonra temizle (duplicate önleme için)
      setTimeout(() => {
        processedRequests.delete(requestSignature);
      }, 5000);
    }
  }

  async function addBedenSetiToCart(originalFetch, userQuantity, selectedVariantId, originalUrl, originalOptions) {
    let selectedRange = null;
    let multiplier = 1;

    const variantSize = getVariantSize(selectedVariantId);

    for (const [range, rangeMultiplier] of Object.entries(variantDistributions)) {
      if (isSizeInRange(variantSize, range)) {
        selectedRange = range;
        multiplier = rangeMultiplier;
        break;
      }
    }

    if (!selectedRange) {
      return {
        success: false,
        errors: [`Seçilen variant için uygun aralık bulunamadı: ${variantSize}`],
        details: [],
        totalAdded: 0
      };
    }

    const finalQuantity = userQuantity * multiplier;

    const stockInfo = sizeVariantStocks[selectedVariantId];
    if (!stockInfo || stockInfo.stock < finalQuantity) {
      return {
        success: false,
        errors: [t('insufficientStockSimpleErr', { available: stockInfo ? stockInfo.stock : 0, needed: finalQuantity })],
        details: [],
        totalAdded: 0
      };
    }

    try {
      const newRequestBody = createSizeRequestBody(originalOptions.body, selectedVariantId, finalQuantity);

      const sizeOptions = {
        ...originalOptions,
        body: newRequestBody,
        headers: {
          ...originalOptions.headers,
          [internalRequestFlag]: 'true'
        }
      };

      const response = await originalFetch.call(this, originalUrl, sizeOptions);

      if (response.ok) {
        return {
          success: true,
          errors: [],
          details: [`${selectedRange}: ${finalQuantity} adet`],
          totalAdded: finalQuantity
        };
      } else {
        const errorText = await response.text();
        return {
          success: false,
          errors: [`HTTP ${response.status}: ${errorText}`],
          details: [],
          totalAdded: 0
        };
      }

    } catch (error) {
      return {
        success: false,
        errors: [`Network error: ${error.message}`],
        details: [],
        totalAdded: 0
      };
    }
  }

  function getVariantSize(variantId) {
    const stockInfo = sizeVariantStocks[variantId];
    if (stockInfo) {
      return stockInfo.sizeName;
    }

    const variantIndex = allSizeVariants.indexOf(variantId);
    if (variantIndex !== -1 && variantIndex < availableSizes.length) {
      return availableSizes[variantIndex];
    }

    return 'UNKNOWN';
  }

  function isSizeInRange(size, range) {
    const cleanSize = size.replace(/[()]/g, '').trim();
    const cleanRange = range.trim();

    if (cleanSize === cleanRange) {
      return true;
    }

    const rangeParts = cleanRange.split('-');
    if (rangeParts.length !== 2) {
      return false;
    }

    const rangeStart = parseInt(rangeParts[0]);
    const rangeEnd = parseInt(rangeParts[1]);

    if (cleanSize.includes('-')) {
      const sizeParts = cleanSize.split('-');
      if (sizeParts.length === 2) {
        const sizeStart = parseInt(sizeParts[0]);
        const sizeEnd = parseInt(sizeParts[1]);
        return sizeStart === rangeStart && sizeEnd === rangeEnd;
      }
    } else {
      const sizeNum = parseInt(cleanSize);
      if (!isNaN(sizeNum) && !isNaN(rangeStart) && !isNaN(rangeEnd)) {
        return sizeNum >= rangeStart && sizeNum <= rangeEnd;
      }
    }

    return false;
  }

  async function addTraditionalSetToCart(originalFetch, userQuantity, originalUrl, originalOptions) {
    const results = {
      success: true,
      errors: [],
      details: [],
      totalAdded: 0
    };

    const isSTDFormat = Object.keys(sizeDistribution).length === 1 && Object.keys(sizeDistribution)[0] === 'STD';

    if (isSTDFormat) {
      const stdQuantity = sizeDistribution['STD'];
      const finalQty = stdQuantity * userQuantity;

      const variantId = allSizeVariants[0];
      if (!variantId) {
        return {
          success: false,
          errors: ['Variant bulunamadı'],
          details: [],
          totalAdded: 0
        };
      }

      let hasStock = true;
      let availableStock = 999999;

      const stockInfo = sizeVariantStocks[variantId];
      if (stockInfo && stockInfo.stock !== undefined && stockInfo.stock !== null) {
        availableStock = stockInfo.stock;
        if (stockInfo.stock < finalQty) {
          hasStock = false;
        }
      }

      if (!hasStock) {
        return {
          success: false,
          errors: [t('insufficientStockSimpleErr', { available: availableStock, needed: finalQty })],
          details: [],
          totalAdded: 0
        };
      }

      try {
        const newRequestBody = createSizeRequestBody(originalOptions.body, variantId, finalQty);

        const sizeOptions = {
          ...originalOptions,
          body: newRequestBody,
          headers: {
            ...originalOptions.headers,
            [internalRequestFlag]: 'true'
          }
        };

        log(`STD Format: Adding ${finalQty} items of variant ${variantId}`);

        const response = await originalFetch.call(this, originalUrl, sizeOptions);

        if (response.ok) {
          results.details.push(`STD: ${finalQty} adet`);
          results.totalAdded += finalQty;
          log(`STD Success: ${finalQty} items added`);
        } else {
          const errorText = await response.text();
          results.errors.push(`STD: HTTP ${response.status}`);
          logError(`STD failed: HTTP ${response.status}`, errorText);
        }

      } catch (error) {
        results.errors.push(`STD: ${error.message}`);
        logError('STD network error:', error);
      }

      // STD format işlemi tamamlandı, fonksiyondan çık
      return results;
    }

    const isPaketFormat = isPaketYapisiFormat;

    if (isPaketFormat) {
      const finalQty = paketMultiplier * userQuantity;

      const variantId = allSizeVariants[0];
      if (!variantId) {
        return {
          success: false,
          errors: ['Variant bulunamadı'],
          details: [],
          totalAdded: 0
        };
      }

      const stockInfo = sizeVariantStocks[variantId];
      if (stockInfo && stockInfo.stock !== undefined && stockInfo.stock !== null && stockInfo.stock < finalQty) {
        return {
          success: false,
          errors: [t('insufficientStockSimpleErr', { available: stockInfo.stock, needed: finalQty })],
          details: [],
          totalAdded: 0
        };
      }

      try {
        const newRequestBody = createSizeRequestBody(originalOptions.body, variantId, finalQty);

        const sizeOptions = {
          ...originalOptions,
          body: newRequestBody,
          headers: {
            ...originalOptions.headers,
            [internalRequestFlag]: 'true'
          }
        };

        log(`Paket Format: Adding ${finalQty} items of variant ${variantId}`);

        const response = await originalFetch.call(this, originalUrl, sizeOptions);

        if (response.ok) {
          results.details.push(`Paket: ${finalQty} adet`);
          results.totalAdded += finalQty;
          log(`Paket Success: ${finalQty} items added`);
        } else {
          const errorText = await response.text();
          results.errors.push(`Paket: HTTP ${response.status}`);
          logError(`Paket failed: HTTP ${response.status}`, errorText);
        }

      } catch (error) {
        results.errors.push(`Paket: ${error.message}`);
        logError('Paket network error:', error);
      }

      // Paket format işlemi tamamlandı, fonksiyondan çık
      return results;
    }

    // Traditional set format (her beden için ayrı ayrı ekleme)
    if (!isSTDFormat && !isPaketFormat) {
      // Set bütünlüğü kontrolü
      const validation = validateSetIntegrity(userQuantity, sizeDistribution);

      if (!validation.isValid) {
        return {
          success: false,
          errors: validation.errors,
          details: [],
          totalAdded: 0
        };
      }

      log(`Set integrity validated. Adding ${userQuantity} sets...`);

      for (const [size, baseQty] of Object.entries(sizeDistribution)) {
        const finalQty = baseQty * userQuantity;
        const variantId = findVariantIdBySize(size);

        if (!variantId) {
          results.errors.push(t('sizeNotFoundErr', { size: size }));
          continue;
        }

        const stockInfo = sizeVariantStocks[variantId];
        if (stockInfo && stockInfo.stock !== undefined && stockInfo.stock !== null && stockInfo.stock < finalQty) {
          results.errors.push(`${size} ${t('insufficientStockSimpleErr', { available: stockInfo.stock, needed: finalQty })}`);
          continue;
        }

        try {
          const newRequestBody = createSizeRequestBody(originalOptions.body, variantId, finalQty);

          const sizeOptions = {
            ...originalOptions,
            body: newRequestBody,
            headers: {
              ...originalOptions.headers,
              [internalRequestFlag]: 'true'
            }
          };

          const response = await originalFetch.call(this, originalUrl, sizeOptions);

          if (response.ok) {
            results.details.push(`${size}: ${finalQty} adet`);
            results.totalAdded += finalQty;
            log(`${size} added successfully: ${finalQty} items`);
          } else {
            const errorText = await response.text();
            results.errors.push(`${size}: HTTP ${response.status}`);
            logError(`${size} failed: HTTP ${response.status}`, errorText);
          }

          await new Promise(resolve => setTimeout(resolve, 500));

        } catch (error) {
          results.errors.push(`${size}: ${error.message}`);
          logError(`${size} network error:`, error);
        }
      }

      if (results.errors.length > 0) {
        results.success = false;
      }

      return results;
    }

    // Hiçbir format eşleşmedi, boş sonuç döndür
    return results;
  }

  function createSizeRequestBody(originalBody, variantId, quantity) {
    if (originalBody instanceof FormData) {
      const newFormData = new FormData();
      for (let [key, value] of originalBody.entries()) {
        if (key === 'id' || key === 'variant_id') {
          newFormData.append(key, variantId);
        } else if (key === 'quantity') {
          newFormData.append(key, quantity);
        } else {
          newFormData.append(key, value);
        }
      }

      if (!newFormData.has('id')) {
        newFormData.append('id', variantId);
      }
      if (!newFormData.has('quantity')) {
        newFormData.append('quantity', quantity);
      }

      return newFormData;
    }

    if (typeof originalBody === 'string') {
      try {
        const json = JSON.parse(originalBody);
        json.id = variantId;
        json.quantity = quantity;
        return JSON.stringify(json);
      } catch (e) {
        let result = originalBody;
        result = result.replace(/[?&]id=([^&]+)/g, `id=${variantId}`);
        result = result.replace(/[?&]quantity=([^&]+)/g, `quantity=${quantity}`);
        if (!result.includes('id=')) {
          result += (result.includes('?') ? '&' : '?') + `id=${variantId}`;
        }
        if (!result.includes('quantity=')) {
          result += `&quantity=${quantity}`;
        }
        return result;
      }
    }

    const fallbackFormData = new FormData();
    fallbackFormData.append('id', variantId);
    fallbackFormData.append('quantity', quantity);
    return fallbackFormData;
  }

  function createRequestSignature(data) {
    const userQty = getQuantityFromData(data);
    const timestamp = Date.now();
    const baseSignature = `qty-${userQty}-time-${Math.floor(timestamp / 5000)}`;
    return baseSignature;
  }

  function getQuantityFromData(data) {
    if (!data) return 1;

    let quantity = 1;

    try {
      if (data instanceof FormData) {
        quantity = parseInt(data.get('quantity')) || 1;
      } else if (typeof data === 'string') {
        try {
          const json = JSON.parse(data);
          quantity = parseInt(json.quantity) || 1;
        } catch (e) {
          const match = data.match(/quantity=(\d+)/);
          quantity = match ? parseInt(match[1]) : 1;
        }
      }
    } catch (e) {
      quantity = 1;
    }

    quantity = Math.max(1, Math.floor(Math.abs(quantity)));
    return quantity;
  }

  function getVariantIdFromData(data) {
    if (!data) return 'unknown';

    try {
      if (data instanceof FormData) {
        return data.get('id') || data.get('variant_id') || 'unknown';
      }

      if (typeof data === 'string') {
        try {
          const json = JSON.parse(data);
          return json.id || json.variant_id || 'unknown';
        } catch (e) {
          const idMatch = data.match(/[?&]id=([^&]+)/);
          return idMatch ? idMatch[1] : 'unknown';
        }
      }
    } catch (e) {
      return 'unknown';
    }

    return 'unknown';
  }

  function triggerCartEvents(cart) {
    try {
      // Validate cart object
      const safeCart = cart || {};
      const itemCount = safeCart.item_count || 0;

      const cartUpdateEvent = new CustomEvent('cart:updated', {
        detail: { cart: safeCart }
      });
      document.dispatchEvent(cartUpdateEvent);

      const events = [
        'cart:update',
        'cart:refresh',
        'cartUpdated',
        'cart-updated',
        'ajaxCart:update'
      ];

      events.forEach(eventName => {
        try {
          const event = new CustomEvent(eventName, {
            detail: { cart: safeCart, itemCount: itemCount }
          });
          document.dispatchEvent(event);
        } catch (e) {
          log('Error dispatching event:', eventName, e.message);
        }
      });

      if (window.jQuery && typeof window.jQuery === 'function') {
        try {
          window.jQuery(document).trigger('cart:updated', [safeCart]);
          window.jQuery(document).trigger('cartUpdated', [safeCart]);
        } catch (e) {
          log('Error triggering jQuery events:', e.message);
        }
      }
    } catch (e) {
      logError('Error in triggerCartEvents:', e.message);
    }
  }

  function updateCartDrawer() {
    try {
      // Method 1: Try cart-drawer custom element
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        if (typeof cartDrawer.open === 'function') {
          cartDrawer.open();
          log('Cart drawer opened via custom element');
          return;
        } else if (typeof cartDrawer.show === 'function') {
          cartDrawer.show();
          log('Cart drawer opened via show method');
          return;
        }
      }

      // Method 2: Try theme cart drawer
      if (window.theme && window.theme.cartDrawer) {
        if (typeof window.theme.cartDrawer.open === 'function') {
          window.theme.cartDrawer.open();
          log('Cart drawer opened via theme object');
          return;
        }
        if (typeof window.theme.cartDrawer.refresh === 'function') {
          window.theme.cartDrawer.refresh();
          log('Cart drawer refreshed via theme object');
        }
      }

      // Method 3: Try Shopify theme events
      if (typeof window.dispatchEvent === 'function') {
        window.dispatchEvent(new CustomEvent('cart:refresh'));
        log('Cart refresh event dispatched');
      }

      // Method 4: Try cart drawer via class selector
      const cartDrawerClass = document.querySelector('.cart-drawer, #cart-drawer');
      if (cartDrawerClass && typeof cartDrawerClass.classList !== 'undefined') {
        cartDrawerClass.classList.add('active', 'is-active', 'open');
        log('Cart drawer activated via class manipulation');
      }
    } catch (e) {
      logError('Error opening cart drawer:', e.message);
    }
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(cart => {
        if (!cart) {
          logError('Cart data is null or undefined');
          return;
        }

        const itemCount = cart.item_count || 0;
        const cartCounters = document.querySelectorAll(
          '.cart-count, [data-cart-count], .cart-item-count, #cart-icon-bubble, .cart-counter'
        );

        cartCounters.forEach(counter => {
          if (counter) {
            counter.textContent = itemCount;
            if (counter.setAttribute) {
              counter.setAttribute('data-cart-count', itemCount);
            }
          }
        });

        triggerCartEvents(cart);

        log('Cart updated:', itemCount);
      })
      .catch(error => {
        logError('Cart update error:', error.message || error);
      });
  }

  forceMultiplier();

})();